import { useStore } from "../index";
import type { EncryptionKeyPair } from "../slices/encryption";

// Hook to get the encryption key pair
export const useKeyPair = (): EncryptionKeyPair | undefined => {
  return useStore((state) => state.keyPair);
};

// Hook to get the public key (base64)
export const usePublicKey = (): string | undefined => {
  return useStore((state) => state.keyPair?.base64.publicKey);
};

// Hook to get profile photo encryption keys
export const useDisplayPhotoKey = (): string | undefined => {
  return useStore((state) => state.displayPhotoKey);
};

export const useCoverPhotoKey = (): string | undefined => {
  return useStore((state) => state.coverPhotoKey);
};

export const useProfileKey = (): string | undefined => {
  return useStore((state) => state.profileKey);
};

// Non-hook getters for use outside React components
export const getKeyPair = (): EncryptionKeyPair | undefined => {
  return useStore.getState().keyPair;
};

export const getPublicKey = (): string | undefined => {
  return useStore.getState().keyPair?.base64.publicKey;
};

export const getSecretKey = (): string | undefined => {
  return useStore.getState().keyPair?.base64.secretKey;
};
